import React from 'react';
import { View } from 'react-native';
import { Icon, type IconName } from './Icon';
import { Text } from './Text';
import { radius, toneColors, useTheme, type Tone } from './theme';

const ICON: Record<Tone, IconName> = { success: 'checkCircle', warning: 'alert', danger: 'alert', info: 'info', neutral: 'info', primary: 'info' };

/** Inline message box. `children` may be a string or a list of strings. */
export function Alert({ tone = 'info', title, children }: { tone?: Tone; title?: string; children?: React.ReactNode | string[] }) {
  const { colors } = useTheme();
  const t = toneColors(colors, tone);
  const lines = Array.isArray(children) && children.every((x) => typeof x === 'string') ? (children as string[]) : null;
  return (
    <View accessibilityRole="alert" style={{ flexDirection: 'row', gap: 10, padding: 12, borderRadius: radius.md, backgroundColor: t.bg, borderWidth: 1, borderColor: t.fg + '33' }}>
      <Icon name={ICON[tone]} size={16} color={t.fg} />
      <View style={{ flex: 1, gap: 2 }}>
        {!!title && (
          <Text weight="semibold" color={t.fg}>
            {title}
          </Text>
        )}
        {lines ? lines.map((l) => <Text key={l} color={t.fg}>• {l}</Text>) : typeof children === 'string' ? <Text color={t.fg}>{children}</Text> : children}
      </View>
    </View>
  );
}
